/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { NotificationDto } from '../../models/notification-dto';
import { UpdateNotificationRequest } from '../../models/update-notification-request';

export interface UpdateNotification$Params {
  id: string;
      body: UpdateNotificationRequest
}

export function updateNotification(http: HttpClient, rootUrl: string, params: UpdateNotification$Params, context?: HttpContext): Observable<StrictHttpResponse<NotificationDto>> {
  const rb = new RequestBuilder(rootUrl, updateNotification.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<NotificationDto>;
    })
  );
}

updateNotification.PATH = '/v0/notifications/{id}';
